import * as React from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { useState } from 'react';
import { Paper } from '@mui/material';

export default function MuiAUtocomplete({
  options,
  dataCy,
  multiple,
  wrapperClasses,
  label,
  onChange,
  value,
  format,
  defaultFormat,
  inputValue,
  onInputChange,
  handleNoOption,
  disabled,
}) {
  if (defaultFormat) format = { value: 'id', label: 'name' };
  const [formatedOptions, setFormatedOptions] = useState([]);
  React.useEffect(() => {
    if (options?.length > 0) {
      let dd = format
        ? options?.map((d) => {
            return { value: d[format?.value], label: d[format?.label] };
          })
        : options;
      setFormatedOptions(dd);
    }
  }, [options, format]);
  const [defaultSelect, setDefaultSelect] = React.useState(null);

  React.useEffect(() => {
    if (multiple) {
      if (value) {
        setDefaultSelect(value);
      }
    } else {
      if (value && formatedOptions?.length > 0) {
        let d = formatedOptions?.find((o) => o.value == value);

        setDefaultSelect(d);
      } else {
      }
    }
  }, [formatedOptions, value, multiple]);
  return (
    <div className={wrapperClasses}>
      {(defaultSelect || !value) && (
        <Autocomplete
          data-cy={dataCy}
          defaultValue={defaultSelect}
          onInputChange={onInputChange}
          onChange={onChange}
          disabled={disabled}
          multiple={multiple}
          id={dataCy}
          options={formatedOptions}
          noOptionsText={handleNoOption}
          sx={{
            minWidth: 150,
            '& .MuiInputLabel-root': { color: 'green', borderColor: 'red' }, // Placeholder color
            '& .MuiInputBase-input': { color: 'green' }, // Text color
            '& .MuiOutlinedInput-root': {},
            '& .MuiAutocomplete-option': {
              backgroundColor: 'red', // Set the background color
            },
          }}
          PaperComponent={(props) => (
            <Paper {...props} sx={{ backgroundColor: '#ffffff' }}>
              {/* Your list content */}
            </Paper>
          )}
          renderInput={(params) => (
            <TextField
              InputProps={{
                'data-cy': `${dataCy}-input`,
                role: `${dataCy}-input`,
              }}
              {...params}
              label={label}
            />
          )}
        />
      )}
    </div>
  );
}
